export const Information = ({ t }) => {
  const paragraphs = t('event.description.paragraphs', { returnObjects: true });
  return (
    <>
      <h2 className='mt-3 mb-3 display-7'>{t('event.description.title')}</h2>
      {/* {paragraphs.map((paragraph, index) => (
        <p
          key={index}
          className='mb-3'
        >
          {paragraph}
        </p>
      ))} */}
      <p>
        <strong>Incluso no pacote:</strong>
      </p>
      <ul>
        <li>Espaço do Treinamento</li>
        <li>
          Alimentação durante o treinamento (almoço, coffee break manhã e tarde)
        </li>
        <li>Produtos para Prática</li>
        <li>Material de Apoio</li>
        <li>Kit Boas Vindas</li>
      </ul>

      <p>
        <strong>O que não está incluso:</strong>
      </p>
      <ul>
        <li>Translado até SP</li>
        <li>Hospedagem</li>
        <li>Jantar</li>
      </ul>

      <p>
        <strong>Responsabilidades do Franqueado:</strong>
      </p>
      <ul>
        <li>Realizar a compra de passagem e hospedagem do participante.</li>
        <li>
          A hospedagem fica a critério do franqueado. Sugerimos que seja próximo
          ao local do evento. (Para apoio, disponibilizaremos futuramente
          sugestões de hospedagem, mas fique à vontade para reservar onde
          preferir).
        </li>
      </ul>

      <p>
        <strong>Informações adicionais:</strong>
      </p>
      <ul>
        <li>
          Como nossa programação começa cedo, sugerimos que os participantes
          cheguem no dia anterior e retornem após as 21h.
        </li>
      </ul>
    </>
  );
};
